import * as types from '../constants/actionTypes';

// set current user
export function setCurrentUser(userId, users) {
    return {
        type: types.SET_CURRENT_USER,
        userId,
        users
    };
}

export function addNewMessage(requestId, user, text) {
    return {
        type: types.ADD_NEW_MESSAGE,
        requestId,
        user,
        text,
        currentDate: new Date()
    }
}

export function addNewRequest(newRequest) {
    return {
        type: types.ADD_NEW_REQUEST,
        newRequest
    }
}


export function approveRequest(requestId, associateOrResource) {
    return {
        type: types.APPROVE_REQUEST,
        requestId,
        associateOrResource
    }
}

export function rejectRequest(requestId, associateOrResource) {
    return {
        type: types.REJECT_REQUEST,
        requestId,
        associateOrResource
    }
}



/** WEBPACK FOOTER **
 ** ./src/actions/actionCreators.js
 **/